export const containerStyles = {
  paddingBottom: '40px',
};

export const formContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const controlsStyles = {
  display: 'flex',
  gap: '4px',
  width: '12%',
  justifyContent: 'center',
  button: {
    minWidth: 'unset',
  },
};

export const tableWrapperStyles = {
  padding: 0,

  '& .table-cell__content_box': {
    overflow: 'visible',
  },
};
